module.exports = __webpack_public_path__ + "media/images/user/lp/step/step3-a3566c0dfebdf45d50f73732dc73e02d.png";